type NullToUndefined<T> = T extends null
  ? undefined
  : T extends Array<infer U>
  ? NullToUndefined<U>[]
  : T extends object
  ? { [K in keyof T]: NullToUndefined<T[K]> }
  : T;

export const nullToUndefined = <T>(value: T): NullToUndefined<T> => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  if (value === null) return undefined as NullToUndefined<T>;
  if (Array.isArray(value))
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value.map(nullToUndefined) as NullToUndefined<T>;
  if (typeof value === 'object') {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.fromEntries(
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      Object.entries(value as object).map(([k, v]) => [k, nullToUndefined(v)])
    ) as NullToUndefined<T>;
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return value as NullToUndefined<T>;
};
